export const data = 

{ 

    first_name: "Francisco",
    last_name: "Campos",
    job: "Software web developer",
    description: "I am a software developer with a passion for web development. I have a strong background in web development and I am currently learning new technologies. I am currently working as a freelancer and I am looking for a new opportunity to work in a team.",    
    social: {
        "linkedin": "https://www.linkedin.com/in/franciscocamposq",
        "github": "https://github.com/camquipc",
        "twitter": "https://twitter.com/fjcqdev",
        "facebook": "https://www.facebook.com/camquipctecni"
    },
    skills: [
        "HTML5",
        "CSS3",
        "JavaScript",
        "PHP",
        "MySQL",
        "MonogDB",
        "Git",
        "Photoshop"
    ],
   projects: [
        {
            name: "JustSport",
            url: "",
            description: "Tienda deportiva online",
            technologies: [
                "Opencart"
            ],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Ftn01.png?alt=media&token=c24bfc57-d760-4d14-906a-c70f1563c344"
        },
        {
            name: "New Sait",
            url: "",
            description: "Sistema administrativo de incidencias tecnológicas",
            technologies: ["NodeJS", "Laravel" ,"PostgreSQL"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fnewsait.png?alt=media&token=216bdd55-2f03-4cf1-b123-2a71f1a51b07"
        },
        {
            name: "Scraping Youtube",
            url: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fscraping.mp4?alt=media&token=55136c3e-9437-453f-a877-c69814e5cdf8",
            description: "App scraping de youtube",
            technologies: ["NodeJS", "Puppeteer","MongoDB"] ,
            type: "video",
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fscraping.mp4?alt=media&token=55136c3e-9437-453f-a877-c69814e5cdf8"
        },
        {
            name: "Catriut",
            url: "",
            description: "Sistema de caja de ahorro",
            technologies:["Laravel","MySQL"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fcat01.png?alt=media&token=11636aaa-1751-4436-8c61-b154b170963e"
        },
        {
            name: "My Portfolio",
            url: "",
            description: "Simple portfolio",
            technologies:["React","Firebase","Bootstrap"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fmp.png?alt=media&token=811764c7-6b56-4fc3-bdff-c63d2596e9dd"
        },
        {
            name: "SitAmbumil",
            url: "",
            description: "Sistema de inventario",
            technologies: ["PHP","PostgreSQL"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Famb.png?alt=media&token=fb93e68d-c9c6-4e6b-b909-ddfd8301c0d6"
        },
        {
            name: "MCC",
            url: "https://ultreyadesolteros.herokuapp.com/",
            description: "Landing del MCC",
            technologies: ["MongoDB", "NodeJS", "Heroku"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fmcc01.png?alt=media&token=f04cc1c6-1a2d-464e-aefd-5f5bec52ec4a"
        },
        {
            name: "App PayBk",
            url: "https://ultreyadesolteros.herokuapp.com/",
            description: "App venta divisas Demo",
            technologies: ["MongoDB ","NodeJS ","ReactJS"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fbk2.png?alt=media&token=04cfa517-db75-4e22-a4bd-22ff6fafd0be"
        },
        {
            name: "Landing para Diócesis de Carúpano",
            url: "",
            description: "Landing para Diócesis de Carúpano",
            technologies:["MongoDB", "NodeJS", "Heroku"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fcpr.png?alt=media&token=b2abd0a5-6682-4bf3-af8e-56129d84aade"
        },
        {
            name: "Catriut",
            url: "",
            description: "Sistema de caja de ahorro",
            technologies: ["Laravel" , "MySQL"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fca02.png?alt=media&token=3c9b9b7b-5b4e-427b-b38c-da7bf5ef53b8"
        },
        {
            name: "Mh-Computer",
            url: "",
            description: "Sistema de inscripción",
            technologies: ["PHP", "MVC" , "PostgreSQL"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fmh01.png?alt=media&token=cf02dbee-a511-4462-9ca3-a4d23fdb429f"
        },
        {
            name: "getBd",
            url: "",
            description: "Mini librería básica",
            technologies: ["PHP"],
            image: "https://firebasestorage.googleapis.com/v0/b/fcampos-dev.appspot.com/o/image-projects%2Fgetbd.png?alt=media&token=fc00106d-f873-444c-a6ba-b1053bd1c84d"
        }
        
    ]


};